import $ from 'jquery';

class MaRSVentureBySector {

  constructor() {
    setTimeout(this.LoadActiveResults(), 750);

    this.resultsDiv = $(".allVenturesBySector__Results");
    this.showButton = $(".allVenturesBySector__link");
    this.searchField = $("#ventureSector-search");
    this.loadMoreButton = $(".allVenturesBySector__load a");
    this.postsPerPage = 12;
    this.screenWidth = $(window).width();
    this.events();
    this.isSpinnerVisible = false;
    this.isOverlayOpen = false;
    this.previousValue;
    this.typingTimer;
    this.loadInfo;
    this.body = $('body');
  }

  events() {
    this.loadMoreButton.on("click", this.getMoreResults.bind(this));
    this.searchField.on("keyup", this.typingLogic.bind(this));
    this.showButton.on("click", this.fetchLogic.bind(this));
  }

  fetchLogic(e) {
    if ($(this)) {
      clearTimeout(this.typingTimer);
      let target = e.target;
      target = target.getAttribute('href');
      target = target.substring(1, target.length);
      let entity = target.split("_").pop();
      let new_target = target.substr(0, target.indexOf('_'));
      if (this.showButton) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults(entity, new_target), 750);
      } else {
        this.resultsDiv.html('');
        this.isSpinnerVisible = false;
      }
    }
  }

  typingLogic() {
    if (this.searchField.val() != this.previousValue) {
      clearTimeout(this.typingTimer);
      if (this.searchField.val()) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
      } else {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
        this.isSpinnerVisible = true;
      }
    }
    this.previousValue = this.searchField.val();
  }

  getResults() {
    if ($(".allVenturesBySector__Results").length) {
      let layout = $('.allVenturesBySector').attr("data-layout");
      let sectorSlug = $('.allVenturesBySector').attr("id");

      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/ventures?term=' + this.searchField.val() + '&sector=' + sectorSlug + '&page=1', (results) => {
        let currentPage = results.current_page;
        if (layout == 1) {
          this.resultsDiv.html(`
            ${results.ventureInfo.length ? '<div class="row no-gutters allVenturesBySector__row">' : '<p>No Venture information matches the search term.</p>'}
              ${results.ventureInfo.map(item => `<a href="${item.company_url}" 
                class="col col-6 col-md-3 allVenturesBySector__link" target="_blank">
                <img class="allVenturesBySector__logo" src="${item.company_logo}">
                <div class="allVenturesBySector__Description">
                  <h3>${item.title}</h3>
                  <p>${item.description}</p> 
                  <span data-href="${item.company_url}" class="allVenturesBySector__extlink" target="_blank">View company website</span>
                </div>               
                </a>`).join('')}
            ${results.ventureInfo.length ? '</div>' : ''}
          </div>
          `);
        } else {
          this.resultsDiv.html(`
          ${results.ventureInfo.length ? '<div class="row no-gutters venturePartnerTab__row">' : '<p>No Venture information matches the search term.</p>'}
          ${results.ventureInfo.map(item => `<a href="${item.company_url}" 
            class="col col-6 col-md-3 venturePartnerTab__cardlink" target="_blank" title="${item.title}" rel="nofollow">
            <img class="venturePartnerTab__logo" src="${item.company_logo}" alt="${item.title}">
            </a>`).join('')}
            ${results.ventureInfo.length ? '</div>' : ''}
        `);
        }
        this.isSpinnerVisible = false;
        this.searchField.val() ? this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&sector=${sectorSlug}&page=2`) : this.loadMoreButton.attr("data-url", `term=&sector=${sectorSlug}&page=2`);
        `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }


  LoadActiveResults() {

    $('.allVenturesBySector').each(function () {
      let sectorSlug = $(this).attr("id");
      let resultsDiv = $("#" + sectorSlug + " .allVenturesBySector__Results");
      let loadMoreButton = $("#" + sectorSlug + " .allVenturesBySector__load a");
      let layout = $('#' + sectorSlug).attr("data-layout");

      if ($("#" + sectorSlug + " .allVenturesBySector__Results").length) {
        $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/ventures?sector=' + sectorSlug + '&page=1', (results) => {
          let currentPage = results.current_page;
          if (layout == 1) {
            resultsDiv.html(`
            ${results.ventureInfo.length ? '<div class="row no-gutters allVenturesBySector__row">' : '<p>No Venture information matches the search term.</p>'}
                ${results.ventureInfo.map(item => `<a href="${item.company_url}" 
                  class="col col-6 col-md-3 allVenturesBySector__link" target="_blank">
                  <img class="allVenturesBySector__logo" src="${item.company_logo}">
                  
                  <div class="allVenturesBySector__Description">
                    <h3>${item.title}</h3>
                    <p>${item.description}</p>
                    <span data-href="${item.company_url}" class="allVenturesBySector__extlink" target="_blank">View company website</span>
                  </div>
                
                  </a>`).join('')}
              ${results.ventureInfo.length ? '</div>' : ''}           
          `);
          } else {
            resultsDiv.html(`
            ${results.ventureInfo.length ? '<div class="row no-gutters venturePartnerTab__row">' : '<p>No Venture information matches the search term.</p>'}
            ${results.ventureInfo.map(item => `<a href="${item.company_url}" 
              class="col col-6 col-md-3 venturePartnerTab__cardlink" target="_blank" title="${item.title}" rel="nofollow">
              <img class="venturePartnerTab__logo" src="${item.company_logo}" alt="${item.title}">
              </a>`).join('')}
              ${results.ventureInfo.length ? '</div>' : ''}
          `);
          }
          this.isSpinnerVisible = false;
          loadMoreButton.attr("data-url", `ventures?sector=${sectorSlug}&page=2`);
          `${results.max_pages == currentPage ? loadMoreButton.hide() : loadMoreButton.show()}`;
        }).fail(function (jqXHR, textStatus, error) {
        });
      }
    });
  }



  getMoreResults(e) {
    e.preventDefault();
    let sectorSlug = e.target.getAttribute("data-id");
    let loadInfo = e.target.getAttribute("data-url");
    let layout = $('#' + sectorSlug).attr("data-layout");
    let currentSector = $('#' + sectorSlug + '.allVenturesBySector').attr("id");
    let resultsDiv = $("#" + sectorSlug + " .allVenturesBySector__Results");
    let loadMoreButton = $("#" + sectorSlug + " .allVenturesBySector__load a");

    if (!this.isSpinnerVisible) {
      resultsDiv.append(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
      this.isSpinnerVisible = true;
    }
    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/' + loadInfo, (results) => {
      let currentPage = results.current_page;
      if (layout == 1) {
        resultsDiv.append(`
            ${results.ventureInfo.length ? '<div class="row no-gutters allVenturesBySector__row">' : ''}
              ${results.ventureInfo.map(item => `<a href="${item.company_url}" 
                class="col col-6 col-md-3 allVenturesBySector__link" target="_blank">
                <img class="allVenturesBySector__logo" src="${item.company_logo}">   
                <div class="allVenturesBySector__Description">
                  <h3>${item.title}</h3>
                  <p>${item.description}</p>
                  <span data-href="${item.company_url}" class="allVenturesBySector__extlink" target="_blank">View company website</span>
                </div>
                </a>`).join('')}
            ${results.ventureInfo.length ? '</div>' : ''}
          </div>
      `);
      } else {
        resultsDiv.append(`
          ${results.ventureInfo.length ? '<div class="row no-gutters venturePartnerTab__row">' : '<p>No Venture information matches the search term.</p>'}
          ${results.ventureInfo.map(item => `<a href="${item.company_url}" 
            class="col col-6 col-md-3 venturePartnerTab__cardlink" target="_blank" title="${item.title}" rel="nofollow">
            <img class="venturePartnerTab__logo" src="${item.company_logo}" alt="${item.title}">
            </a>`).join('')}
            ${results.ventureInfo.length ? '</div>' : ''}
        `);
      }

      setTimeout(function () {
        let elmnt = document.querySelectorAll("#" + sectorSlug + " .allVenturesBySector__Results .venturePartnerTab__row");
        if (elmnt.length == 0) {
          elmnt = document.querySelectorAll("#" + sectorSlug + " .allVenturesBySector__Results .allVenturesBySector__row");
        }

        elmnt = elmnt[elmnt.length - 1];
        let offset = $(elmnt).offset();
        $('html, body').animate({
          scrollTop: offset.top - 70,
          scrollLeft: offset.left
        });
      }, 500);

      $('.sk-double-bounce').remove();
      this.isSpinnerVisible = false;
      loadMoreButton.attr("data-url", `ventures?sector=${currentSector}&page=${parseInt(currentPage) + 1}`);
      /*if (this.searchField.val().length > 1) {
        this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=${parseInt(currentPage) + 1}`);
      } else {
        this.loadMoreButton.attr("data-url", `sector=${currentSector[0]}&page=${parseInt(currentPage) + 1}`);
      }*/
      `${results.max_pages == currentPage ? loadMoreButton.hide() : loadMoreButton.show()}`;

    }).fail(function (jqXHR, textStatus, error) {
    });
  }
}

export default MaRSVentureBySector;